module.exports = __webpack_public_path__ + "img/panier.1997c5c4.svg";